enum Routes {
  Home = '/',
  AboutMe = '/about-me',
  Sandbox = '/sandbox/:slug',
}

export default Routes;
